export default "<p>retailer-dashboard works!</p>\n";